import { useTranslation, withTranslation } from "react-i18next";
import withRouter from "../../../../../components/Common/withRouter";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const DeleteBonusSetting = ({open, handleToggle, clickActionCallback, fermerModal}) => {
    const { t } = useTranslation();
    return (
        <Modal isOpen={open} toggle={handleToggle} centered >
            <ModalHeader toggle={fermerModal}>
                {t("confirm_delete")}
            </ModalHeader>
            <ModalBody>
                    Are you sure to want to delete this record ?
            </ModalBody>
            <ModalFooter>
            <Button color="danger" onClick={clickActionCallback}>
                      {t("delete")}
            </Button>
            <Button color="secondary" onClick={fermerModal}>
                {t("cancel")}
            </Button>
            </ModalFooter>
        </Modal>
    );
};

export default withRouter(withTranslation()(DeleteBonusSetting))